import React from "react";
import { motion } from "framer-motion";

const ABGResults = ({ steps, finalDiagnosis }) => {
  return (
    <div className="glass-card p-6 rounded-xl shadow-2xl mt-8">
      <h2 className="text-2xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">
        ABG Analysis Results
      </h2>

      <div className="mb-6">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="bg-gradient-to-r from-blue-500/20 to-purple-500/20 p-5 rounded-lg border-l-4 border-blue-400 backdrop-blur-sm"
        >
          <h3 className="text-xl font-semibold text-blue-300">
            Final Diagnosis
          </h3>
          <p className="text-lg mt-2 text-gray-200">{finalDiagnosis}</p>
        </motion.div>
      </div>

      <div className="space-y-6">
        {steps.map((step, index) => (
          <motion.div
            key={index}
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            className={`p-5 rounded-lg border-l-4 backdrop-blur-sm ${
              step.isNormal
                ? "bg-green-500/20 border-green-400"
                : "bg-amber-500/20 border-amber-400"
            }`}
          >
            <h3 className="text-lg font-semibold text-gray-200">{step.title}</h3>
            <p className="text-gray-400 text-sm mb-2">{step.description}</p>

            {step.calculation && (
              <div className="bg-black/30 p-3 rounded my-2 font-mono text-sm text-cyan-300 border border-white/10">
                {step.calculation}
              </div>
            )}

            <div className="flex items-center mt-2">
              <span className="font-semibold mr-2 text-gray-300">Result:</span>
              <span
                className={`${
                  step.isNormal ? "text-green-400" : "text-amber-400"
                } font-medium`}
              >
                {step.result}
              </span>
            </div>

            {step.details && (
              <div className="text-gray-300 text-sm mt-2">
                {step.details.split("\n").map((line, i) => (
                  <p key={i} className="mb-1">
                    {line}
                  </p>
                ))}
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ABGResults;
